(function () {
  'use strict';

  /* ALCO 10-oct-2026: el panel ahora también se usa bien con el teclado.
     · Flecha abajo, o Tab sobre PRODUCTOS con el panel abierto, entra a las categorías.
     · Flechas arriba/abajo recorren las categorías; flecha derecha (o Tab) entra a sus líneas;
       flecha izquierda (o Mayús+Tab desde la primera línea) regresa a la categoría; dentro de
       las líneas, flechas arriba/abajo las recorren.
       Sólo la categoría activa está en el orden del tabulador (tabindex itinerante, como en
       unas pestañas): Tab nunca salta a otra categoría ni le cambia el panel al usuario.
     · Al salir del panel con Tab sigue en el menú (MAYOREO); con Mayús+Tab regresa a PRODUCTOS.
     · La foto grande de cada categoría se baja hasta que se abre el menú (data-alco-src).
     · Escape sólo actúa si el panel está abierto (antes, Escape en cualquier parte de la
       página le daba el foco a PRODUCTOS y con eso ABRÍA el menú). */
  var DELAY = 180; // ms antes de cerrar tras salir del area
  var closeTimer = null;
  var panel, btn, catBtns, linesPanels;
  var sinAbrirAlFoco = false;
  var fotosPedidas = false;

  // Pasa data-alco-src/srcset a src/srcset (la foto grande no se baja hasta abrir el menú).
  function cargarFoto(img) {
    if (!img || !img.hasAttribute('data-alco-src')) return;
    var ss = img.getAttribute('data-alco-srcset');
    if (ss) img.setAttribute('srcset', ss);
    img.setAttribute('src', img.getAttribute('data-alco-src'));
    img.removeAttribute('data-alco-srcset');
    img.removeAttribute('data-alco-src');
  }
  function cargarFotos() {
    if (fotosPedidas || !panel) return;
    fotosPedidas = true;
    // Primero la de la categoría activa; las demás en seguida, para que al pasar el ratón ya estén.
    var act = linesPanels.filter(function (p) { return p.classList.contains('is-active'); })[0];
    if (act) cargarFoto(act.querySelector('img[data-alco-src]'));
    setTimeout(function () {
      Array.from(panel.querySelectorAll('img[data-alco-src]')).forEach(cargarFoto);
    }, 300);
  }

  function open() {
    if (!panel) return;
    clearTimeout(closeTimer);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    cargarFotos();
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-open');
    // Si MAYOREO quedó abierto (p. ej. al llegar con el teclado), se cierra: nunca los dos a la vez.
    var may = document.getElementById('alco-mayoreo-panel');
    if (may && may.classList.contains('is-open')) {
      may.classList.remove('is-open');
      may.setAttribute('aria-hidden', 'true');
      var mayBtn = document.getElementById('alco-mayoreo-btn');
      if (mayBtn) { mayBtn.classList.remove('is-open'); mayBtn.setAttribute('aria-expanded', 'false'); }
    }
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, DELAY);
  }

  function close() {
    if (!panel) return;
    clearTimeout(closeTimer);
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    btn.classList.remove('is-open');
  }

  function isOpen() { return !!panel && panel.classList.contains('is-open'); }

  function activateCat(idx) {
    catBtns.forEach(function (b) {
      var active = b.dataset.cat === String(idx);
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', String(active));
      b.tabIndex = active ? 0 : -1;
    });
    linesPanels.forEach(function (p) {
      var active = p.dataset.cat === String(idx);
      p.classList.toggle('is-active', active);
      p.setAttribute('aria-hidden', String(!active));
      if (active && fotosPedidas) cargarFoto(p.querySelector('img[data-alco-src]'));
    });
  }

  function activeBtn() {
    return catBtns.filter(function (b) { return b.classList.contains('is-active'); })[0] || catBtns[0];
  }
  function activeLinks() {
    var p = linesPanels.filter(function (x) { return x.classList.contains('is-active'); })[0];
    return p ? Array.from(p.querySelectorAll('a[href]:not([tabindex="-1"])')) : [];
  }
  // Lo que se puede enfocar en el encabezado después de PRODUCTOS (para seguir con Tab).
  function siguienteDelMenu() {
    var raiz = btn.closest('header') || document;
    var todos = Array.from(raiz.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([type="hidden"]), summary'))
      .filter(function (el) { return el.offsetParent !== null && !panel.contains(el); });
    var i = todos.indexOf(btn);
    return i >= 0 ? todos[i + 1] : null;
  }
  function enfocarCategoria() {
    open();
    var b = activeBtn();
    if (!b) return;
    activateCat(b.dataset.cat);
    // Espera a que el panel deje de estar «visibility: hidden» para poder enfocar.
    requestAnimationFrame(function () { b.focus(); });
  }

  function initMegaMenu() {
    btn         = document.getElementById('alco-productos-btn');
    panel       = document.getElementById('alco-mega-panel');
    if (!btn || !panel) return;
    // Sólo los de ESTE panel (MAYOREO usa las mismas clases).
    catBtns     = Array.from(panel.querySelectorAll('.alco-mega-cat-btn'));
    linesPanels = Array.from(panel.querySelectorAll('.alco-mega-lines'));
    if (!catBtns.length) return;
    activateCat(activeBtn().dataset.cat); // deja puesto el tabindex itinerante desde el principio

    // PRODUCTOS hover → abrir
    btn.addEventListener('mouseenter', open);
    btn.addEventListener('mouseleave', scheduleClose);
    btn.addEventListener('focus', function () {
      if (sinAbrirAlFoco) { sinAbrirAlFoco = false; return; }
      open();
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey && isOpen())) {
        e.preventDefault();
        enfocarCategoria();
      }
    });

    // Dentro del panel → cancelar cierre
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);

    // Hover / foco / clic sobre categoría izquierda → mostrar líneas derechas
    catBtns.forEach(function (b, i) {
      b.addEventListener('mouseenter', function () { activateCat(b.dataset.cat); });
      b.addEventListener('click', function () { activateCat(b.dataset.cat); });
      b.addEventListener('focus', function () { activateCat(b.dataset.cat); });
      b.addEventListener('keydown', function (e) {
        var destino = null;
        if (e.key === 'ArrowDown') destino = catBtns[(i + 1) % catBtns.length];
        else if (e.key === 'ArrowUp') destino = catBtns[(i - 1 + catBtns.length) % catBtns.length];
        else if (e.key === 'Home') destino = catBtns[0];
        else if (e.key === 'End') destino = catBtns[catBtns.length - 1];
        else if (e.key === 'ArrowRight') {
          activateCat(b.dataset.cat);
          var ls = activeLinks();
          if (ls.length) { e.preventDefault(); requestAnimationFrame(function () { ls[0].focus(); }); }
          return;
        }
        if (destino) { e.preventDefault(); destino.focus(); }
      });
    });
    linesPanels.forEach(function (p) {
      p.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); var b = activeBtn(); if (b) b.focus(); return; }
        // Flechas arriba/abajo recorren las líneas de la categoría (sin dar la vuelta).
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          var ls = activeLinks();
          var i = ls.indexOf(document.activeElement);
          if (i < 0) return;
          var j = e.key === 'ArrowDown' ? Math.min(i + 1, ls.length - 1) : Math.max(i - 1, 0);
          e.preventDefault();
          ls[j].focus();
        }
      });
    });

    // Tab dentro del panel: de la categoría activa pasa a SUS líneas; del último enlace sigue en el
    // menú (MAYOREO). Mayús+Tab: de la primera línea regresa a su categoría y de la categoría a PRODUCTOS.
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var a = document.activeElement;
      var ls = activeLinks();
      var esCat = catBtns.indexOf(a) >= 0;
      if (e.shiftKey) {
        if (esCat) { e.preventDefault(); sinAbrirAlFoco = true; btn.focus(); }
        else if (ls.length && a === ls[0]) { e.preventDefault(); activeBtn().focus(); }
        return;
      }
      if (esCat && ls.length) { e.preventDefault(); ls[0].focus(); return; }
      if (esCat || (ls.length && a === ls[ls.length - 1])) {
        var sig = siguienteDelMenu();
        if (sig) { e.preventDefault(); close(); sig.focus(); }
      }
    });
    // Si el foco se va a otra parte de la página, se cierra.
    panel.addEventListener('focusout', function (e) {
      var a = e.relatedTarget;
      if (a && !panel.contains(a) && a !== btn) close();
    });

    // Cerrar con Escape (sólo si está abierto) o clic fuera
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        var dentro = panel.contains(document.activeElement) || document.activeElement === btn;
        close();
        if (dentro && document.activeElement !== btn) { sinAbrirAlFoco = true; btn.focus(); }
        sinAbrirAlFoco = false;
      }
    });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && !btn.contains(e.target)) close();
    });

    // Asegurar primera categoría activa al abrir
    panel.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'opacity' && panel.classList.contains('is-open')) {
        if (!catBtns.some(function (b) { return b.classList.contains('is-active'); })) {
          activateCat(0);
        }
      }
    }, { once: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();


// ── ALCO Mayoreo Mega Menu ──────────────────────────────────────────────────
(function () {
  'use strict';

  /* ALCO 12-oct-2026: MAYOREO con fotos y con teclado, igual que PRODUCTOS (10-oct).
     · La foto grande de cada canal se baja hasta que se abre el menú (data-alco-src).
     · Flecha abajo, o Tab sobre MAYOREO con el panel abierto, entra a los canales; flechas
       arriba/abajo los recorren; flecha derecha (o Tab) entra a sus enlaces; flecha izquierda
       (o Mayús+Tab desde el primer enlace) regresa al canal; dentro de los enlaces, flechas
       arriba/abajo los recorren. Sólo el canal activo está en el orden del tabulador (tabindex
       itinerante). Enter sobre un canal abre su página, como el clic.
     · Al salir del panel con Tab sigue en el menú (QUIÉNES SOMOS); con Mayús+Tab regresa a MAYOREO.
     · Escape cierra y deja el foco en MAYOREO sin volver a abrir el panel (antes lo reabría). */
  var DELAY = 180;
  var closeTimer = null;
  var panel, btn, catBtns, linesPanels;
  var sinAbrirAlFoco = false;
  var fotosPedidas = false;

  // Pasa data-alco-src/srcset a src/srcset (la foto grande no se baja hasta abrir el menú).
  function cargarFoto(img) {
    if (!img || !img.hasAttribute('data-alco-src')) return;
    var ss = img.getAttribute('data-alco-srcset');
    if (ss) img.setAttribute('srcset', ss);
    img.setAttribute('src', img.getAttribute('data-alco-src'));
    img.removeAttribute('data-alco-srcset');
    img.removeAttribute('data-alco-src');
  }
  function cargarFotos() {
    if (fotosPedidas || !panel) return;
    fotosPedidas = true;
    // Primero la del canal activo; las demás en seguida, para que al pasar el ratón ya estén.
    var act = linesPanels.filter(function (p) { return p.classList.contains('is-active'); })[0];
    if (act) cargarFoto(act.querySelector('img[data-alco-src]'));
    setTimeout(function () {
      Array.from(panel.querySelectorAll('img[data-alco-src]')).forEach(cargarFoto);
    }, 300);
  }

  function open() {
    if (!panel) return;
    clearTimeout(closeTimer);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-open');
    // Activar primer canal si ninguno está activo
    if (!catBtns.some(function(b){ return b.classList.contains('is-active'); })) {
      activateCat(0);
    }
    cargarFotos();
    // Cerrar el panel de PRODUCTOS si estuviera abierto
    var prodPanel = document.getElementById('alco-mega-panel');
    if (prodPanel) {
      prodPanel.classList.remove('is-open');
      prodPanel.setAttribute('aria-hidden', 'true');
      var prodBtn = document.getElementById('alco-productos-btn');
      if (prodBtn) { prodBtn.classList.remove('is-open'); prodBtn.setAttribute('aria-expanded', 'false'); }
    }
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, DELAY);
  }

  function close() {
    if (!panel) return;
    clearTimeout(closeTimer);
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    btn.classList.remove('is-open');
  }

  function isOpen() { return !!panel && panel.classList.contains('is-open'); }

  function activateCat(idx) {
    catBtns.forEach(function (b) {
      var active = b.dataset.mayoreoCat === String(idx);
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', String(active));
      b.tabIndex = active ? 0 : -1;
    });
    linesPanels.forEach(function (p) {
      var active = p.dataset.mayoreoCat === String(idx);
      p.classList.toggle('is-active', active);
      p.setAttribute('aria-hidden', String(!active));
      if (active && fotosPedidas) cargarFoto(p.querySelector('img[data-alco-src]'));
    });
  }

  function activeBtn() {
    return catBtns.filter(function (b) { return b.classList.contains('is-active'); })[0] || catBtns[0];
  }
  function activeLinks() {
    var p = linesPanels.filter(function (x) { return x.classList.contains('is-active'); })[0];
    return p ? Array.from(p.querySelectorAll('a[href]:not([tabindex="-1"])')) : [];
  }
  // Lo que se puede enfocar en el encabezado después de MAYOREO (sin su flecha ni el panel).
  function siguienteDelMenu() {
    var raiz = btn.closest('header') || document;
    var todos = Array.from(raiz.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([type="hidden"]), summary'))
      .filter(function (el) { return el.offsetParent !== null && !panel.contains(el) && (el === btn || !btn.contains(el)); });
    var i = todos.indexOf(btn);
    return i >= 0 ? todos[i + 1] : null;
  }
  function enfocarCategoria() {
    open();
    var b = activeBtn();
    if (!b) return;
    activateCat(b.dataset.mayoreoCat);
    // Espera a que el panel deje de estar «visibility: hidden» para poder enfocar.
    requestAnimationFrame(function () { b.focus(); });
  }

  function initMayoreoMenu() {
    btn         = document.getElementById('alco-mayoreo-btn');
    panel       = document.getElementById('alco-mayoreo-panel');
    if (!btn || !panel) return;
    // Antes solo 'BUTTON': los 4 canales ahora son <a href> reales para navegar directo
    // al hacer clic (Fernando, 2026-07-28); se conserva 'BUTTON' por si algún canal futuro
    // vuelve a usar ese tag, y se agrega 'A' para no perder la vista previa al pasar el mouse.
    // Sólo los de ESTE panel (PRODUCTOS usa las mismas clases).
    catBtns     = Array.from(panel.querySelectorAll('[data-mayoreo-cat]')).filter(function (el) { return el.tagName === 'BUTTON' || el.tagName === 'A'; });
    linesPanels = Array.from(panel.querySelectorAll('[data-mayoreo-cat]')).filter(function (el) { return el.tagName === 'DIV'; });
    if (catBtns.length) activateCat(activeBtn().dataset.mayoreoCat); // deja puesto el tabindex itinerante

    btn.addEventListener('mouseenter', open);
    btn.addEventListener('mouseleave', scheduleClose);
    btn.addEventListener('focus', function () {
      if (sinAbrirAlFoco) { sinAbrirAlFoco = false; return; }
      open();
    });
    btn.addEventListener('keydown', function (e) {
      if (e.target !== btn || !catBtns.length) return; // la flecha (span dentro del enlace) va por su lado
      if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey && isOpen())) {
        e.preventDefault();
        enfocarCategoria();
      }
    });
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);
    var arrow = document.getElementById('alco-mayoreo-arrow');
    if (arrow) {
    arrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-open')) { close(); } else { open(); }
    })
    // 12-oct (revisión): con el teclado la flecha no hacía nada (Mayús+Tab desde QUIÉNES SOMOS caía en
    // ella). Enter, Espacio o flecha abajo abren y entran a los canales; Tab con el panel abierto, también.
    arrow.addEventListener('keydown', function (e) {
      if (!catBtns.length) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.key === 'ArrowDown' ||
          (e.key === 'Tab' && !e.shiftKey && isOpen())) {
        e.preventDefault();
        e.stopPropagation();
        enfocarCategoria();
      }
    });
    }

    catBtns.forEach(function (b, i) {
      b.addEventListener('mouseenter', function () { activateCat(b.dataset.mayoreoCat); });
      b.addEventListener('click', function () { activateCat(b.dataset.mayoreoCat); });
      b.addEventListener('focus', function () { activateCat(b.dataset.mayoreoCat); });
      b.addEventListener('keydown', function (e) {
        var destino = null;
        if (e.key === 'ArrowDown') destino = catBtns[(i + 1) % catBtns.length];
        else if (e.key === 'ArrowUp') destino = catBtns[(i - 1 + catBtns.length) % catBtns.length];
        else if (e.key === 'Home') destino = catBtns[0];
        else if (e.key === 'End') destino = catBtns[catBtns.length - 1];
        else if (e.key === 'ArrowRight') {
          activateCat(b.dataset.mayoreoCat);
          var ls = activeLinks();
          if (ls.length) { e.preventDefault(); requestAnimationFrame(function () { ls[0].focus(); }); }
          return;
        }
        if (destino) { e.preventDefault(); destino.focus(); }
      });
    });
    linesPanels.forEach(function (p) {
      p.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); var b = activeBtn(); if (b) b.focus(); return; }
        // Flechas arriba/abajo recorren los enlaces del canal (sin dar la vuelta).
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          var ls = activeLinks();
          var i = ls.indexOf(document.activeElement);
          if (i < 0) return;
          var j = e.key === 'ArrowDown' ? Math.min(i + 1, ls.length - 1) : Math.max(i - 1, 0);
          e.preventDefault();
          ls[j].focus();
        }
      });
    });

    // Tab dentro del panel: del canal activo pasa a SUS enlaces; del último enlace sigue en el menú
    // (QUIÉNES SOMOS). Mayús+Tab: del primer enlace regresa a su canal y del canal a MAYOREO.
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !catBtns.length) return;
      var a = document.activeElement;
      var ls = activeLinks();
      var esCat = catBtns.indexOf(a) >= 0;
      if (e.shiftKey) {
        if (esCat) { e.preventDefault(); sinAbrirAlFoco = true; btn.focus(); }
        else if (ls.length && a === ls[0]) { e.preventDefault(); activeBtn().focus(); }
        return;
      }
      if (esCat && ls.length) { e.preventDefault(); ls[0].focus(); return; }
      if (esCat || (ls.length && a === ls[ls.length - 1])) {
        var sig = siguienteDelMenu();
        if (sig) { e.preventDefault(); close(); sig.focus(); }
      }
    });
    // Si el foco se va a otra parte de la página, se cierra.
    panel.addEventListener('focusout', function (e) {
      var a = e.relatedTarget;
      if (a && !panel.contains(a) && !btn.contains(a)) close();
    });

    document.addEventListener('keydown', function (e) {
      // ALCO 10-oct-2026: sólo si el panel está abierto; antes Escape en cualquier parte le daba el foco
      // al botón y con eso abría el panel. 12-oct: el foco regresa a MAYOREO sin reabrirlo.
      if (e.key === 'Escape' && isOpen()) {
        var dentro = panel.contains(document.activeElement) || btn.contains(document.activeElement);
        close();
        if (dentro && document.activeElement !== btn) { sinAbrirAlFoco = true; btn.focus(); }
        sinAbrirAlFoco = false;
      }
    });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== btn) close();
    });
  }

  // También hacer que el panel de PRODUCTOS se cierre cuando Mayoreo se abre
  var prodBtn = null;
  function patchProductosBtn() {
    prodBtn = document.getElementById('alco-productos-btn');
    if (prodBtn) {
      prodBtn.addEventListener('mouseenter', function () {
        var mayPanel = document.getElementById('alco-mayoreo-panel');
        if (mayPanel) {
          mayPanel.classList.remove('is-open');
          mayPanel.setAttribute('aria-hidden', 'true');
          var mayBtn = document.getElementById('alco-mayoreo-btn');
          if (mayBtn) { mayBtn.classList.remove('is-open'); mayBtn.setAttribute('aria-expanded', 'false'); }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMayoreoMenu(); patchProductosBtn(); });
  } else {
    initMayoreoMenu();
    patchProductosBtn();
  }
})();

/* ── ALCO 5-oct-2026 · «Productos» en el menú del CELULAR ───────────────────
   El menú del celular (menu-drawer de Dawn) usa la lista alco-dawn-nav-1, que
   no trae Productos: el catálogo sólo vivía en el mega menú de escritorio.
   Aquí se arma un acordeón Productos → categoría → líneas leyendo el MISMO
   #alco-mega-panel, así lo que se edite en el mega menú sale también aquí. */
(function () {
  'use strict';

  var CSS = [
    '.alco-mob-prod summary{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between}',
    '.alco-mob-prod summary::-webkit-details-marker{display:none}',
    '.alco-mob-chev{width:.8rem;height:.8rem;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);transition:transform .2s;margin:0 .4rem 0 1rem;flex:none}',
    '.alco-mob-prod details[open]>summary>.alco-mob-chev{transform:rotate(-135deg)}',
    '.alco-mob-prod ul{list-style:none;margin:0;padding:0}',
    '.alco-mob-cats>li>details>summary{padding:1rem 3rem 1rem 4.2rem;font-size:1.6rem;font-weight:600;color:rgb(var(--color-foreground))}',
    /* ALCO 10-oct-2026: foto de la categoría junto al nombre (la misma del mega menú). */
    '.alco-mob-cats>li>details>summary.alco-mob-cat--foto{justify-content:flex-start;gap:1.2rem;padding:.7rem 2.4rem .7rem 3rem;font-size:1.5rem}',
    '.alco-mob-thumb{flex:none;width:4.8rem;height:4.8rem;border-radius:1.2rem;object-fit:cover;background:#fff;box-shadow:0 2px 8px rgba(16,18,58,.14)}',
    '.alco-mob-cat__txt{flex:1;min-width:0;line-height:1.25}',
    '.alco-mob-cats--foto .alco-mob-lines a{padding-left:9rem}',
    '.alco-mob-prod .alco-mob-cats--foto>li>a.alco-mob-vertodo{padding-left:3rem}',
    '.alco-mob-lines a{display:block;padding:.75rem 3rem .75rem 5.6rem;font-size:1.5rem;color:rgba(var(--color-foreground),.8);text-decoration:none}',
    '.alco-mob-lines a:hover,.alco-mob-lines a:focus{color:rgb(var(--color-foreground));background:rgba(var(--color-foreground),.04)}',
    '.alco-mob-prod a.alco-mob-vertodo{font-weight:700;color:#1a1aa8}',
    '.alco-mob-cats>li>a.alco-mob-vertodo{display:block;padding:1rem 3rem 1.4rem 4.2rem;font-size:1.6rem;text-decoration:none}',
    '.alco-mob-cats{padding-bottom:.6rem}',
    '.alco-mob-prod>details[open]{background:rgba(var(--color-foreground),.03)}'
  ].join('\n');

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function chev() { var s = el('span', 'alco-mob-chev'); s.setAttribute('aria-hidden', 'true'); return s; }
  function liga(href, texto, cls) { var a = el('a', cls || '', texto); a.href = href; return a; }

  function armar() {
    var ul = document.querySelector('#menu-drawer .menu-drawer__menu');
    var panel = document.getElementById('alco-mega-panel');
    if (!ul || !panel || ul.querySelector('.alco-mob-prod')) return;
    var cats = panel.querySelectorAll('.alco-mega-cat-btn');
    if (!cats.length) return;

    var raiz = el('details', 'alco-mob-acc');
    var sum = el('summary', 'menu-drawer__menu-item list-menu__item link link--text focus-inset', 'Productos');
    sum.appendChild(chev());
    raiz.appendChild(sum);
    var lista = el('ul', 'alco-mob-cats');
    lista.setAttribute('role', 'list');

    Array.prototype.forEach.call(cats, function (b) {
      var lineas = panel.querySelector('.alco-mega-lines[data-cat="' + b.dataset.cat + '"]');
      if (!lineas) return;
      var li = el('li');
      var det = el('details');
      var etiqueta = b.querySelector('.alco-mega-cat-btn__label');
      var nombre = ((etiqueta || b).textContent || '').trim();
      var s = el('summary');
      var foto = b.querySelector('.alco-mega-cat-btn__thumb img');
      if (foto) {
        var mini = document.createElement('img');
        mini.className = 'alco-mob-thumb';
        mini.src = foto.currentSrc || foto.getAttribute('src');
        mini.alt = '';
        mini.width = 48; mini.height = 48;
        mini.loading = 'lazy'; mini.decoding = 'async';
        s.className = 'alco-mob-cat--foto';
        s.appendChild(mini);
        lista.classList.add('alco-mob-cats--foto');
      }
      s.appendChild(el('span', 'alco-mob-cat__txt', nombre));
      s.appendChild(chev());
      det.appendChild(s);
      var sub = el('ul', 'alco-mob-lines');
      sub.setAttribute('role', 'list');
      var ver = lineas.querySelector('.alco-mega-lines__ver-todo-top');
      if (ver) { var lv = el('li'); lv.appendChild(liga(ver.getAttribute('href'), 'Ver todo', 'alco-mob-vertodo')); sub.appendChild(lv); }
      Array.prototype.forEach.call(lineas.querySelectorAll('.alco-mega-lines__link'), function (a) {
        var l = el('li'); l.appendChild(liga(a.getAttribute('href'), (a.textContent || '').trim())); sub.appendChild(l);
      });
      det.appendChild(sub);
      li.appendChild(det);
      lista.appendChild(li);
    });
    var todos = el('li');
    todos.appendChild(liga('/collections/all', 'Ver todos los productos', 'alco-mob-vertodo'));
    lista.appendChild(todos);
    raiz.appendChild(lista);

    var item = el('li', 'alco-mob-prod');
    item.appendChild(raiz);
    ul.insertBefore(item, ul.firstChild);

    if (!document.getElementById('alco-mob-prod-css')) {
      var st = el('style', null, CSS);
      st.id = 'alco-mob-prod-css';
      document.head.appendChild(st);
    }
  }

  /* ALCO 12-oct-2026: «Mayoreo» en el celular con la misma foto de cada canal que el mega menú
     MAYOREO (Jesús: «al menú de mayoreo le faltan sus fotos»). Antes era un enlace directo a la
     página general; ahora es un acordeón como Productos: Mayoreo → canal (miniatura + nombre) →
     «Ver página completa» y sus productos. La página general queda al final («Ver todo Mayoreo»).
     Se arma leyendo #alco-mayoreo-panel, así lo que se edite en el mega menú sale también aquí. */
  function armarMayoreo() {
    var ul = document.querySelector('#menu-drawer .menu-drawer__menu');
    var panel = document.getElementById('alco-mayoreo-panel');
    var orig = document.getElementById('HeaderDrawer-mayoreo');
    if (!ul || !panel || !orig || ul.querySelector('.alco-mob-may')) return;
    var liOrig = orig.closest('li');
    var cats = panel.querySelectorAll('.alco-mega-cat-btn');
    if (!liOrig || !cats.length) return;

    var raiz = el('details', 'alco-mob-acc');
    var sum = el('summary', 'menu-drawer__menu-item list-menu__item link link--text focus-inset', (orig.textContent || '').trim() || 'Mayoreo');
    sum.appendChild(chev());
    raiz.appendChild(sum);
    var lista = el('ul', 'alco-mob-cats');
    lista.setAttribute('role', 'list');

    Array.prototype.forEach.call(cats, function (b) {
      var lineas = panel.querySelector('.alco-mega-lines[data-mayoreo-cat="' + b.dataset.mayoreoCat + '"]');
      if (!lineas) return;
      var li = el('li');
      var det = el('details');
      var etiqueta = b.querySelector('.alco-mega-cat-btn__label');
      var nombre = ((etiqueta || b).textContent || '').trim();
      var s = el('summary');
      var foto = b.querySelector('.alco-mega-cat-btn__thumb img');
      if (foto) {
        var mini = document.createElement('img');
        mini.className = 'alco-mob-thumb';
        mini.src = foto.currentSrc || foto.getAttribute('src');
        mini.alt = '';
        mini.width = 48; mini.height = 48;
        mini.loading = 'lazy'; mini.decoding = 'async';
        s.className = 'alco-mob-cat--foto';
        s.appendChild(mini);
        lista.classList.add('alco-mob-cats--foto');
      }
      s.appendChild(el('span', 'alco-mob-cat__txt', nombre));
      s.appendChild(chev());
      det.appendChild(s);
      var sub = el('ul', 'alco-mob-lines');
      sub.setAttribute('role', 'list');
      var ver = lineas.querySelector('.alco-mega-lines__ver-todo-top');
      if (ver) { var lv = el('li'); lv.appendChild(liga(ver.getAttribute('href'), 'Ver página completa', 'alco-mob-vertodo')); sub.appendChild(lv); }
      Array.prototype.forEach.call(lineas.querySelectorAll('.alco-mayoreo-canal__prod-link'), function (a) {
        var l = el('li'); l.appendChild(liga(a.getAttribute('href'), (a.textContent || '').trim())); sub.appendChild(l);
      });
      det.appendChild(sub);
      li.appendChild(det);
      lista.appendChild(li);
    });
    var todos = el('li');
    todos.appendChild(liga(orig.getAttribute('href'), 'Ver todo Mayoreo', 'alco-mob-vertodo'));
    lista.appendChild(todos);
    raiz.appendChild(lista);

    var item = el('li', 'alco-mob-prod alco-mob-may');
    item.appendChild(raiz);
    ul.insertBefore(item, liOrig);
    liOrig.style.display = 'none';

    if (!document.getElementById('alco-mob-prod-css')) {
      var st = el('style', null, CSS);
      st.id = 'alco-mob-prod-css';
      document.head.appendChild(st);
    }
  }

  function armarTodo() { armar(); armarMayoreo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armarTodo);
  else armarTodo();
})();
